import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {UtilsService} from '../../utils/utils.service';
import {ParametreImageEnum} from '../../enums/parametre-image-enum';


export const URL_POST_SAVE_PARAMETERS = `dolrest/utils/preferences/save`;

export const URL_DELETE_PARAMETRE_IMAGE = `dolrest/utils/parametre-image`;

@Injectable({
  providedIn: 'root'
})
export class ParametresService {

  constructor(private http: HttpClient,
              private utils: UtilsService) {
  }


  savePreferences(bgFile: File, logoFile:File,  useTauxDePrise: Boolean ) {
    const fd = new FormData();
    fd.set('bgFile', bgFile);
    fd.set('logoFile',logoFile);

    return this.http.post(`${URL_POST_SAVE_PARAMETERS}/${useTauxDePrise}`, fd)
      .pipe(
        catchError(error => this.utils.handleError(error))
      );

  }

  /**
   * Supprime l'image personnalisée d'un paramétrage.
   *
   * C'est aussi ce qui rétablit l'image par défaut : le back retombe sur celle livrée avec l'application dès que
   * le fichier personnalisé est absent. Il n'y a donc pas de second appel de restauration à enchaîner.
   */
  removeParametreImage(parametreImage: ParametreImageEnum): Observable<any> {
    return this.http.delete(`${URL_DELETE_PARAMETRE_IMAGE}/${parametreImage}`)
      .pipe(
        catchError(error => this.utils.handleError(error))
      );
  }
}
